import { render, staticRenderFns } from "./styleStandard.vue?vue&type=template&id=80784876&scoped=true&"
import script from "./styleStandard.vue?vue&type=script&lang=js&"
export * from "./styleStandard.vue?vue&type=script&lang=js&"
import style0 from "./styleStandard.vue?vue&type=style&index=0&id=80784876&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80784876",
  null
  
)

export default component.exports